function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#8DDBCD"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M13.18.82C12.65.291 11.947 0 11.199 0s-1.452.291-1.98.82L1.388 8.65c-.066.066-.114.15-.14.24L.02 13.306c-.053.191.001.395.141.535.104.103.243.159.386.159.05 0 .1-.007.15-.02l4.417-1.256c.186-.053.33-.2.38-.388.049-.187-.005-.387-.142-.524L2.567 9.02l6.489-6.49 2.413 2.414-4.968 4.954c-.213.213-.214.56 0 .773.213.214.559.215.773.001l5.906-5.89c.529-.528.82-1.232.82-1.98s-.291-1.451-.82-1.98zM3.92 11.926l-2.586.735.724-2.602 1.862 1.867zm8.486-7.918l-.163.163-2.415-2.415.163-.162c.322-.323.75-.5 1.207-.5.456 0 .885.177 1.207.5.323.322.5.751.5 1.207 0 .456-.177.885-.5 1.207z",
  transform: "translate(-280 -80) translate(280 40) translate(0 40)"
})))));

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.6a77ca15.svg";
export { ForwardRef as ReactComponent };